
import { findRelatedMessages } from "@/utils/api";

/**
 * Determines the next version number for a regenerated message
 */
export const getNextVersionNumber = async (
  refundRequestId: string, 
  messageId: string,
  originalMessageId: string
): Promise<number> => {
  // Get all related messages to determine version
  const relatedMessages = await findRelatedMessages(refundRequestId, messageId);
  
  // Calculate the next version number
  const currentVersions = relatedMessages.map(msg => msg.version || 1);
  const nextVersion = currentVersions.length > 0 ? Math.max(...currentVersions) + 1 : 1;
  
  console.log(`Regenerating message ${messageId} as version ${nextVersion}`);
  
  return nextVersion;
};
